if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"counsellor_web","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(285|528)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}